import { intervalToDuration } from 'date-fns';
import React from 'react';

import useTimer from '@swf/core/hooks/useTimer';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import styles from '../CMSEventTournament.scss';

const getFormattedTimestamp = (timeValue: number) => {
  if (timeValue < 0) {
    return;
  }

  const duration = intervalToDuration({ start: 0, end: timeValue || 0 });
  let res = '';
  if (duration.hours) {
    res += duration.hours < 10 ? `0${duration.hours}` : duration.hours;
  }

  if (duration.minutes || duration.hours) {
    const minutes = duration.minutes || 0;
    res = res ? `${res}:` : res;
    res += minutes < 10 ? `0${duration.minutes}` : duration.minutes;
  }

  if (duration.seconds || duration.minutes) {
    const seconds = duration.seconds || 0;
    res = res ? `${res}:` : res;
    res += seconds < 10 ? `0${duration.seconds}` : duration.seconds;
  }

  return res;
};

export interface ClockData {
  elapsedTime: number;
  nextBreakTime: number;
  levelTime: number;
  onLevelTimeExpired: () => void;
}

const timeIncrement = (time: number) => time + 1000;
const timeDecrement = (time: number) => time - 1000;

const Clock: React.FC<ClockData> = ({
  elapsedTime,
  nextBreakTime,
  levelTime,
  onLevelTimeExpired
}) => {
  const levelTimeClock = useTimer({ modifier: timeDecrement, initial: levelTime });
  const nextBreakClock = useTimer({ modifier: timeDecrement, initial: nextBreakTime });
  const elapsedClock = useTimer({ modifier: timeIncrement, initial: elapsedTime });

  if (levelTimeClock < 0) {
    onLevelTimeExpired();
  }

  return (
    <div className={styles.clocksContainer}>
      <div className={styles.layoutItem}>
        <div className={styles.layoutLabel}>Next Break</div>
        <div>{getFormattedTimestamp(nextBreakClock)}</div>
      </div>
      <div className={styles.layoutItem}>
        <span className={styles.levelDuration}>{getFormattedTimestamp(levelTimeClock)}</span>
      </div>
      <div className={styles.layoutItem}>
        <div className={styles.layoutLabel}>Time Elapsed</div>
        <div>{getFormattedTimestamp(elapsedClock)}</div>
      </div>
    </div>
  );
};

export default Clock;
